import React, { useState, useEffect, useContext } from 'react'
import { Button } from 'syngenta-react-components'
import DetailView from '../../../dpe-usco/components/Details/DetailView'
import useApiHelper from '../../../services/useApiHelper'
import { GlobalContext } from '../../../services/context'
import { useParams } from 'react-router-dom'
import TableStatus from '../../../components/subComponents/TableStatus/TableStatus'

const MasterAgreementPDFView = props => {
  const { dispatch } = useContext(GlobalContext)
  const { contract_template_id } = useParams()
  const [_contract_template_id] = useState(contract_template_id)
  const [
    { data: contractTemplatesData, status: templateStatus },
    getContractTemplates
  ] = useApiHelper('getContractTemplates')

  const handleGoBack = () => {
    dispatch({ type: 'GO_BACK' })
  }

  useEffect(() => {
    let canceled = false
    const init = async () => {
      getContractTemplates(_contract_template_id, 'contract_template_id')
    }
    if (_contract_template_id && !canceled) {
      init()
    }

    return () => {
      canceled = true
    }
  }, [_contract_template_id, getContractTemplates])

  let content
  switch (templateStatus) {
    case 'LOADING':
      content = (
        <>
          <p>Fetching PDF</p>
          <TableStatus status="LOADING" />
        </>
      )
      break
    case 'EMPTY':
      content = (
        <>
          <p>Failed to retrieve the contract PDF</p>
          <Button
            styleType="success"
            text="Go Back"
            clickHandler={handleGoBack}
            customClassName="mb10"
          />
        </>
      )
      break
    case null:
      content = (
        <>
          <object
            data={contractTemplatesData.template_doc_link}
            type="application/pdf"
            style={{ width: '100%', height: '75vh' }}
          >
            <p>This browser does not support PDFs.</p>
          </object>
        </>
      )
      break
    default:
      break
  }

  return (
    <DetailView
      button={
        <Button
          styleType="success"
          text="Go Back"
          clickHandler={handleGoBack}
          customClassName="mb10"
        />
      }
    >
      <div className="pt20">{content}</div>
      <></>
    </DetailView>
  )
}

export default MasterAgreementPDFView
